var FALSE = false,
TRUE = true,
NULL = null,
LEN = "length",
TYPE_STR = "string",
TYPE_OBJ = "object",
TYPE_UNDEF = "undefined",
NEG_ONE = -1,
fitt = require("fitt"),
fittStrReplace = fitt.strReplace,
ParamHash = require("fitt-paramhash"),
nodeURL = typeof XMLHttpRequest === TYPE_UNDEF ? require('url') : NULL,
exp = {},
mix = fitt.mix,
cstr = fitt.cstr,
subStr = fitt.subStr,
strlc = fitt.strlc,
idxOf = fitt.idxOf,
charAt = fitt.charAt,
strMatch = fitt.strMatch,
regxTest = fitt.regxTest,
strReplace = fitt.strReplace,
trim = fitt.trim,

PATH = "path",
PRTCL = "protocol",
HOST = "host",
HASH = "hash",
PARAMS = "params",
PORT = "port",
FWD_SLASH = "/",
COLON = ":",
HASHTAG = "#",
QUEST = "?",
EQ = "=",
AMP = "&",
SCHEME_SEP = COLON + FWD_SLASH + FWD_SLASH,
DOUBLE_SLASH = FWD_SLASH + FWD_SLASH,
URL_MAX_LENGTH = 4096,
URLClassProto = {},


rURLSplitter = /^(http\:|https\:|file\:|ftp\:)*?(?:\/)+([-\w\.]+)(\:\d+)?(([^\s\?#]*)(\?\S[^#]*)*(#\S*)*)/i,
rProtocolSearch = /http\:|https\:|file\:|ftp:\:/gi,
rIsRelative = /^(\.\.\/|\.\/|\/)/,
rStripRelPath = /^(\/*)(\.*)/g,
rURLPathEnd = /\S[^\?#]*/,
rGoUp = /(^\.\.\/)/,
rStayHere = /(^\.\/)/,
rRoot = /(^\/)/,
rColonMatch = /\:/g,
rDigitMatch = /^\d+/,

prevLocStr = "", /* store the last known browser window location string if avail */
prevRefStr = "", /* store the last known browser window location document referrer if avail */

oBrowserLoc = NULL, /* store the current / last known browser location as an {@link fitt.URL} instance */
oBrowserRef = NULL; /* store the current / last known document referrer as an {@link fitt.URL} instance */


/**
                                                                                                            * Utility function to get the URL value for either the current browser document, or the document referrer,
                                                                                                            * from the browser.  Not used server-side.
                                                                                                            *
                                                                                                            * @name fitt.URL-getDocURL
                                                                                                            * @function
                                                                                                            * @static
                                                                                                            * @private
                                                                                                            * @param {Number} mode Which URL to get at, 0/default being the current window/document location, 1 being the document referrer.
                                                                                                            * @return {fitt.URL} an instance of the fitt.URL object representing the given/requested URL string.
                                                                                                            *
                                                                                                           */

function getDocURL(mode)
{
	var url = NULL,href;
	if (!mode) {
		/*
              * location.href may be inaccessible due to weirdness with document.domain in
                       * in IE.  So use try/catches and also look at document.URL if needed.
              		*/

		try {
			href = location.href;
		} catch (e) {
			href = '';
		}
		if (!href) {
			try {
				href = document.URL;
			} catch (e) {
				href = '';
			}
		}
		if (href) {
			/*
              * only reconstruct the URL object if the location has changed
             */
			if (href != prevLocStr) {
				prevLocStr = href;
				url =
				oBrowserLoc = new URLClass(href);
			} else {
				url = oBrowserLoc;
			}
		}
	} else {
		try {
			href = document.referrer;
		} catch (e) {
			href = '';
		}
		if (href) {
			if (href != prevRefStr) {
				prevRefStr = href;
				url =
				oBrowserRef = new URLClass(href);
			} else {
				url = oBrowserRef;
			}
		}
	}
	return url;
}

/**
   * Get the current document location as an {@link fitt.URL} object
   * Note that this function currently returns NULL when run server-side since
   * it's not really viable but that could change in the future (say if we wanted
   * to run this code with some sort of virutal document server side).
   *
   * @name fitt.URL.loc
   * @function
   * @public
   * @static
   * @return {fitt.URL}
  */

function loc() {return getDocURL();}

/**
                                      * Get the current document referrer as an {@link fitt.URL} object
                                         * Returns null if document.refferer is not available (i.e. server-side,
                                         * or when a the given document has no referrer);
                                         *
                                         * @name fitt.URL.ref
                                         * @function
                                         * @public
                                         * @static
                                         * @return {fitt.URL|Null}
                                        */


function ref() {return getDocURL(1);}

/**
                                       * A utility function for the {@link fitt.URL.resolve} method that
                                       * mixes the URL object properties into another object
                                       *
                                       * @name fitt-resolve_mixForOutput
                                       * @private
                                       * @function
                                       * @param {URLClass} retURL
                                       * @param {Object} out
                                       * @return {URLClass} retURL
                                      */

function resolve_mixForOutput(retURL, out)
{
	if (retURL && retURL instanceof URLClass && retURL.isValid()) {
		if (out) {
			mix(out, retURL, TRUE, TRUE, FALSE, TRUE);
		}
	} else {
		retURL = NULL;
	}
	return retURL;
}

/**
   * Converts a relative path string to a fully qualified absolute URL, using either
   * the base URL string passed in or if not provided will use the document/page location
   * See {@link fitt.URL.resolve} for more information
   *
   * @name fitt-resolve_clientSide
   * @function
   * @private
   * @param {String} str The URL string
  * @param {String} [base] An optional base URL to use for converting the relative path.  When running client-side, this value will default to the current
  *                        document location that the code is running in.  Server-Side this defaults to an empty string, and becomes a REQUIRED parameter.
  * @param {Object} out  The object to be used as an output parameter, which will mix in properties that make it look like a {@link fitt.URL} object (having
  *                      host, path and protocol properties set if the conversion the relative URL to absolute is successful).
  * @return {fitt.URL}
  */

function resolve_clientSide(str, base, out) {
	var idx = 0,retURL = NULL,sProto,sPort,sHost,sPath,sMyPath,execResult,sHash,oBaseURL;

	if (base) {
		oBaseURL = new URLClass(base);
	} else if (oBrowserLoc) {
		oBaseURL = oBrowserLoc;
	}

	if (!oBaseURL || !oBaseURL.isValid()) {
		throw new Error("fitt.URL.resolve failed, no URL base provided or detected " + str);
	}

	out = out || {};
	sProto = oBaseURL[PRTCL];
	sHost = oBaseURL[HOST];
	sMyPath = oBaseURL[PATH];
	sPort = oBaseURL[PORT];
	sHash = oBaseURL[HASH];
	sPath = strMatch(str, rURLPathEnd);
	if (sPath) {
		sPath = sPath[0];
	}

	if (!regxTest(rRoot, sPath)) {
		if (regxTest(rStayHere, sPath)) {
			sPath = strReplace(sPath, rStayHere, '', TRUE, TRUE);
			idx = idxOf(sMyPath, FWD_SLASH, 1);
			if (idx != NEG_ONE)
			sPath = subStr(sMyPath, 0, idx + 1) + sPath;

		} else {
			while (execResult = rGoUp.exec(sPath))
			{
				idx = idxOf(sMyPath, FWD_SLASH, 1);
				if (idx != NEG_ONE) {
					sMyPath = subStr(sMyPath, 0, idx);
					sPath = strReplace(sPath, execResult[1], '', FALSE, TRUE);
				} else {
					break;
				}
			}
			sPath = cstr([sMyPath, FWD_SLASH, sPath]);
		}
	}

	if (sPath) {
		sPath = strReplace(sPath, rStripRelPath, '');
		sPath = idxOf(sPath, FWD_SLASH) !== 0 ? FWD_SLASH + sPath : sPath;
	}
	retURL = new URLClass(cstr([sProto, SCHEME_SEP, sHost, sPort ? COLON : '', sPort, sPath, sHash ? HASHTAG : '', sHash]));

	return resolve_mixForOutput(retURL, out);
}

/**
   * Converts a relative path string to a fully qualified absolute URL, using
   * the base URL string passed in. This method takes advantage of using the NodeJS 'url'
   * module for functionality.
   * See {@link fitt.URL.resolve} for more information
   *
   * @name fitt-resolve_serverSide
   * @function
   * @private
   * @param {String} str The URL string
  * @param {String} [base] An optional base URL to use for converting the relative path.  When running client-side, this value will default to the current
  *                        document location that the code is running in.  Server-Side this defaults to an empty string, and becomes a REQUIRED parameter.
  * @param {Object} out  The object to be used as an output parameter, which will mix in properties that make it look like a {@link fitt.URL} object (having
  *                      host, path and protocol properties set if the conversion the relative URL to absolute is successful).
  * @return {fitt.URL}
  */

function resolve_serverSide(str, base, out)
{
	var retURL = NULL,resolvedStr,oBaseURL;

	if (!nodeURL) {
		throw new Error("fitt.URL.resolve, node 'url' module not found");
	}

	if (base) {
		oBaseURL = new URLClass(base);
	}

	if (!oBaseURL || !oBaseURL.isValid()) {
		throw new Error("fitt.URL.resolve failed, no URL base provided or detected " + str);
	}

	resolvedStr = nodeURL.resolve(base, str);
	retURL = new URLClass(resolvedStr);
	out = out || {};

	return resolve_mixForOutput(retURL, out);

}

/**
  * A method for converting relative URLs to absolute URLs.
  *
  *
  * @name fitt.URL.resolve
  * @static
  * @param {String} str The URL string
  * @param {String} [base] An optional base URL to use for converting the relative path.  When running client-side, this value will default to the current
  *                        document location that the code is running in.  Server-Side this defaults to an empty string, and becomes a REQUIRED parameter.
  * @param {Object} out  The object to be used as an output parameter, which will mix in properties that make it look like a {@link fitt.URL} object (having
  *                      host, path and protocol properties set if the conversion the relative URL to absolute is successful).
  * @return {fitt.URL}
  *
  */

function resolve(str, base, out) {};


resolve = nodeURL ? resolve_serverSide : resolve_clientSide;


/**
                                                              * Parses a string representation of a URL, using the NodeJS url module, parse method.
                                                              *
                                                              * @name fitt.URL-parse_serverSide
                                                              * @function
                                                              * @private
                                                              * @param {String} str  The URL string
                                                              * @param {Object} out  The object to be used as an output parameter, which will have host, path, port, params, and protocol properties set if the conversion the relative URL to absolute is successful.
                                                              * @param {Boolean} [ret=false] Also return a new fully qualified URL object if desired.
                                                              * @return {Object}
                                                              *
                                                             */

function parse_serverSide(str)
{
	var out = {},resolvedNodeURL;

	if (!nodeURL) {
		throw new Error("fitt.URL.parse, node 'url' module not found");
	}

	resolvedNodeURL = nodeURL.parse(str, TRUE, TRUE);

	out[HOST] = cstr(resolvedNodeURL.hostname);
	out[PATH] = fittStrReplace(cstr(resolvedNodeURL[PATH]), /\?.*$/, '', TRUE, TRUE);
	out[PARAMS] = fittStrReplace(cstr(resolvedNodeURL.search), /^\?/, '', TRUE, TRUE);
	out[PORT] = cstr(resolvedNodeURL[PORT]);
	out[HASH] = cstr(resolvedNodeURL[HASH]);
	out[PRTCL] = fittStrReplace(cstr(resolvedNodeURL[PRTCL]), /\:/g, '', TRUE, TRUE);

	return out;
}

/**
      * Parses a string representation of a URL.
      *
      * @name fitt.URL-parse_clientSide
      * @function
      * @private
      * @param {String} str  The URL string
      * @param {Object} out  The object to be used as an output parameter, which will have host, path, port, params, and protocol properties set if the conversion the relative URL to absolute is successful.
      * @param {Boolean} [ret=false] Also return a new fully qualified URL object if desired.
      * @return {fitt.URL|void} return a new {@link fitt.URL} object if ret param is set to true, otherwise return undefined (relying on the object in the out param).
      *
     */

function parse_clientSide(str)
{
	var out = {},sProtocol = '',sHost = '',sPath = '',sParams = '',sHash = '',match,sPort = '',idx = 0;

	if (str) {
		if (!str.search(rIsRelative)) {
			if (idxOf(str, DOUBLE_SLASH) != 0) {
				resolve_clientSide(str, null, out);
				str = cstr([out[PRTCL], SCHEME_SEP, out[HOST], out[PORT] ? COLON + out[PORT] : '', FWD_SLASH, out[PATH]]);
			} else {
				//it's protocol relative, not a relative path
			}
		}
		match = strMatch(str, rURLSplitter);
		if (match) {
			sProtocol = match[1] || '';
			sHost = match[2] || '';
			sPort = match[3] || '';
			sPath = match[5] || '';
			sParams = match[6] || '';
			sHash = match[7] || '';
		}

		if (sProtocol) {
			sProtocol = strReplace(sProtocol, rColonMatch, '', TRUE, TRUE);
			if (strlc(sProtocol, TRUE) == "file" && sHost && sPath && charAt(sPath, 0) == COLON) {
				sPath = sHost + sPath;
				sHost = '';
			}
		}

		if (sPort) sPort = strReplace(sPort, rColonMatch, '', TRUE, TRUE);
		if (sParams && charAt(sParams, 0) == QUEST) sParams = subStr(sParams, 1);
		if (sHash && charAt(sHash, 0) == HASHTAG) sHash = subStr(sHash, 1);
		//if (sPath && charAt(sPath,0) == FWD_SLASH) sPath = subStr(sPath,1);

		if (sHash) {
			idx = idxOf(sHash, QUEST);
			if (idx != NEG_ONE) {
				sParams = subStr(sHash, idx + 1);
				sHash = subStr(sHash, 0, idx);
			}
		}
	}
	out[PRTCL] = sProtocol;
	out[HOST] = sHost;
	out[PORT] = sPort;
	out[PATH] = sPath;
	out[PARAMS] = sParams;
	out[HASH] = sHash;

	return out;

}

/**
      * Parses a string representation of a URL
      *
      * @name fitt.URL.parse
      * @function
      * @public
      * @param {String} str  The URL string
      * @return {Object}
      *
     */

function parse(str)
{
	if (nodeURL) return parse_serverSide(str);

	return parse_clientSide(str);
}

/**
   * Instantiable class used to convert a URL string into an object.
   * For example:
   * <pre>
        var str  = "http://localhost:8080/foo/bar.html?cb=0293842034&#hello";
        var oURL = new fitt.URL(str);
        alert(oURL.protocol); //echo's "http"
        alert(oURL.port); //echo's "8080"
        alert(oURL.host); //echo's localhost
        alert(oURL.path); //echo's "foo/bar.html"
        alert(oURL.params); //echo's "cb=0293842034&"
        alert(oURL.hash); //echo's "#hello"
   * </pre>
   *
   *
   *
   * @class
   * @name fitt.URL
   * @param {String} sProtocolOrURLString  A string representing a URL in total if it is the only argument specified to the constructor.  Otherwise it is treated as the protocol string part of a URL.
   * @param {String} sHost  A string representing a URL host name
   * @param {String} sPath  A string representing a URL path
   * @param {String/Object} oParams  A string representation or object representation of a fitt.ParamHash object that is used as query string parameters on a URL.
   * @param {String} sHash  A string representing a URL hash
   * @param {String} sPort  A string representing a URL port
   *
   * @property {String} protocol The protocol of the URL.  Supported values are "http", "https", "ftp", and "file"
   * @property {String} host The host name (cname) of the URL.  Will be empty for file URLs
   * @property {String} path The path of the URL, including the file name/mime type.  Note that nested URLs
      *                         will be treated as part of the path.<br />
      *
      * <pre>
  Example: http://www.yahoo.com/rds**http%3A//sports.yahoo.com/nfl/blog/shutdown_corner/post/The-best-and-worst-of-the-2010-draft%3Furn=nfl,236463
                              |                                                                                                                  |
                              |--------------------------------------------- PATH ---------------------------------------------------------------|
       </pre>
      *
      * @property {String} port The port number string of the URL.  Will be empty for file URLs
      * @property {String} hash The hash value of the URL.<br /> <pre>(e.g. "#hashvalue")</pre>
      * @property {fitt.ParamHash} params The query string parameters of the URL. <br /> <pre>(e.g. "?foo=bar&name=value&")</pre>
   *
  */
function URLClass(sProtocolOrURLString, sHost, sPath, oParams, sHash, sPort) {

	if (!this || !(this instanceof URLClass)) return new URLClass(sProtocolOrURLString, sHost, sPath, oParams, sHash, sPort);

	var me = this,argLen = arguments[LEN],match,isRelative = FALSE,sProto,obj,objTyp,
	failedResolve = FALSE;

	me[PRTCL] =
	me[HOST] =
	me[PATH] =
	me[HASH] =
	me[PORT] = '';
	me[PARAMS] = NULL;

	if (!argLen) return me;

	sProtocolOrURLString = cstr(sProtocolOrURLString);

	if (argLen == 1 || sProtocolOrURLString && !sHost && !sPath && !oParams && !sHash && !sPort) {
		obj = parse(sProtocolOrURLString);
		mix(me, obj, TRUE, TRUE);
	} else {
		if (idxOf(sProtocolOrURLString, COLON) == -1) sProtocolOrURLString += COLON;
		match = strMatch(sProtocolOrURLString, rProtocolSearch, 0);
		if (match) {
			sProto =
			me[PRTCL] = match;
			sProto =
			me[PRTCL] = strReplace(me[PRTCL], rColonMatch, '', TRUE, TRUE);
		}

		sHost = cstr(sHost);
		if (sHost) {
			me[HOST] = sHost;
		} else {
			obj = parse_clientSide(sProtocolOrURLString);
			if (obj[HOST]) me[HOST] = obj[HOST];
		}

		if (sPort && strMatch(sPort, rDigitMatch)) {
			me[PORT] = sPort;
		} else {
			obj = obj || parse_clientSide(sProtocolOrURLString);
			if (obj[PORT]) me[PORT] = obj[PORT];
		}

		sPath = cstr(sPath);
		if (sPath) {
			isRelative = !!strMatch(sPath, rIsRelative);

			if (isRelative) {
				try {
					resolve_clientSide(sPath, me[PRTCL] && me[HOST] ? cstr([me[PRTCL], SCHEME_SEP, me[HOST]]) : NULL, me);
				} catch (e) {
					failedResolve = true;
					/* if we fail converting relative, note that and
                            * just use what was passed
                           */
				}

				if (sHost && sHost != me[HOST]) {
					me[HOST] = sHost;
				}
				if (sProto && sProto != me[PRTCL]) {
					me[PRTCL] = sProto;
				}
				if (sPort != me[PORT]) {
					me[PORT] = sPort;
				}

				if (failedResolve) {
					//Remove any relative paths if we can't resolve as they don't make sense
					me[PATH] = sPath;
				}

				if (me[PATH]) {
					me[PATH] = strReplace(me[PATH], rStripRelPath, '');
					me[PATH] = idxOf(me[PATH], FWD_SLASH) !== 0 ? FWD_SLASH + me[PATH] : me[PATH];
				}

			} else {
				me[PATH] = sPath;
			}
		} else {
			obj = obj || parse_clientSide(sProtocolOrURLString);
			if (obj[PATH]) me[PATH] = obj[PATH];
		}

		if (sHash) {
			me[HASH] = sHash;
		} else {
			obj = obj || parse_clientSide(sProtocolOrURLString);
			if (obj[HASH]) me[HASH] = obj[HASH];
		}

		if (oParams) {
			me[PARAMS] = oParams;
		} else {
			obj = obj || parse_clientSide(sProtocolOrURLString);
			if (obj[PARAMS]) me[PARAMS] = obj[PARAMS];
		}
	}

	//if hash and query string are transposed, and there is no path, the hash will show up as the path so fix it here
	if (!idxOf(me[PATH], HASHTAG)) {
		me[HASH] = subStr(me[PATH], 1);
		me[PATH] = '';
	}

	try {
		obj = me[PARAMS];
		objTyp = obj && typeof obj || '';

		if (objTyp == TYPE_STR) {
			me[PARAMS] = ParamHash(obj, AMP, EQ);
		} else if (objTyp == TYPE_OBJ) {
			if (!(obj instanceof ParamHash)) {
				me[PARAMS] = ParamHash(obj, AMP, EQ);
			} else {
				me[PARAMS] = obj;
			}
		}
	} catch (e) {
		me[PARAMS] = NULL;
	}
}


/**
  * Checks whether or not an instance of a fitt.URL class is valid or not.  This method checks that all pieces of a URL
  * are set properly, as well as checking the maximum length.
  *
  * @name fitt.URL#isValid
  * @function
  * @public
  * @return {Boolean} if the URL instance validates
  *
  */
function isValid(oURL)
{
	var tmpStr = '',me = oURL || this || {},protocol = me[PRTCL],host = me[HOST],port = me[PORT];

	if (protocol != "file") {
		if (!host) return FALSE;
		if (port && !strMatch(port, rDigitMatch)) return FALSE;
		protocol += COLON;
		if (!protocol.search(rProtocolSearch)) {
			tmpStr = cstr([protocol, SCHEME_SEP, host, port ? COLON + port : '', FWD_SLASH, me[PATH]]);
			if (tmpStr[LEN] > URL_MAX_LENGTH) return FALSE;
			if (!strMatch(host, /^[-\w\.]+/i)) return FALSE;
			return !!tmpStr;
		} else {
			return TRUE;
		}
	} else {
		return !!host;
	}
}

/**
   * A static method to validate a URL string. See isValid method for more details.
   *
   * @name fitt.URL.validate
   * @function
   * @static
   * @param {String} str  A string representation of a URL.
   * @return {Boolean} if the URL validates.
   *
  */

function validate(str)
{
	var strtyp = str && typeof str || '';

	switch (strtyp) {

		case 'string':
			return isValid(new URLClass(str));
		case 'object':
			return str instanceof URLClass ? isValid(str) : isValid(new URLClass(cstr(str)));}

	return FALSE;
}

/**
   * Whether or not a given URL is using SSL (https protocol)
   *
   * @name fitt.URL#isSSL
   * @function
   * @public
   * @return {Boolean}
  */

/**
      * Whether or not a given URL is using SSL (https protocol)
      *
      * @name fitt.URL.isSSL
      * @function
      * @public
      * @static
      * @param {fitt.URL|String} str The URL to process
      * @return {Boolean}
     */

function isSSL(str)
{
	var url = str || this || NULL,
	urltyp = url && typeof url || '';

	switch (urltyp) {

		case 'string':
			url = new URLClass(url);
			break;
		case 'object':
			url = url instanceof URLClass ? url : new URLClass(cstr(url));
			break;}


	return url && cstr(url[PRTCL]).search(/^https/i) === 0;
}

/**
   * A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
   * RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
   * by any combination of letters, digits, plus, period, or hyphen.
   *
   * @name fitt.URL.isAbsolute
   * @function
   * @public
   * @static
   * @param {String|fitt.URL} url The URL to check
   * @return {Boolean} whether or not the URL is absolute
  */

function isAbsolute(url)
{
	return (/^(http\:|https\:|file\:|ftp:\:)/i.test(cstr(url)));
}

/**
  * Outputs a {@link fitt.URL} object as a string (assuming it's valid)
  *
  * @name fitt.URL#toString
  * @function
  * @public
  * @return {String} representation of a URL
  *
  */

function URLClass_toString()
{
	var buf,me = this,sProtcl,path,params,aHash,sPort,l;

	try {
		if (!isValid(me)) return '';
	} catch (e) {
		return '';
	}

	sProtcl = me[PRTCL];
	sProtcl = strReplace(sProtcl, rColonMatch, '');
	params = me[PARAMS];
	path = me[PATH];
	aHash = me[HASH];
	sPort = me[PORT];
	buf = [sProtcl, sProtcl ? SCHEME_SEP : DOUBLE_SLASH, me[HOST]];

	if (sPort)
	buf.push(COLON, sPort);

	if (!path) {
		buf.push(FWD_SLASH);
	} else if (strMatch(path, /\/|\w+/g)) {
		buf.push(charAt(path, 0) !== FWD_SLASH ? FWD_SLASH : '', path);
	}

	if (params && params instanceof ParamHash) {
		params = trim(cstr(params), TRUE) || '';
		if (params) {
			l = params[LEN];
			if (l && charAt(params, l - 1) == AMP) params = subStr(params, 0, l - 1);
		}
		/* Only push a question mark char on the end if we do indeed have querystring params */
		if (params) {
			buf.push(QUEST, params);
		}
	}

	if (aHash)
	buf.push(HASHTAG, aHash);

	return cstr(buf);
}

/**
   * Return a string representation of a URL minus any query string, port, or hash tag values
   *
   * @name fitt.URL#toStripString
   * @function
   * @public
   * @return {String}
  */

function URLClass_toStripString()
{
	var ret = '',me = this || {},prot = me[PRTCL],pt = me[PATH],hst = me[HOST];
	if (hst) ret = cstr([prot, prot ? SCHEME_SEP : DOUBLE_SLASH, hst, charAt(pt, 0) !== FWD_SLASH ? FWD_SLASH : '', pt]);
	return ret;
}

/**
  * Return host name optionally with protocol and port number
  * Used for cases such as calling postMessage where you need those
  * values in addition to just the cname. By default includes the protocol, since
  * otherwise you could just ask for [oURL].host
  *
  * @name fitt.URL#toHostString
  * @function
  * @public
  * @param {Boolean} [withProto=true] Include the protocol with the host name, defaults to true, must past false to have this ignored (falsy values such as 0/null will still behave as defaulting to true)
  * @param {Boolean} [withPort=false] Include the port number in the string, defaults to false
  * @param {Number} [subCount=*] Include a number to limit the number of sub domains that are repoted on the host
  *                              Must be a number of 2 or greater (since any hostname must have at least 2 words seperated by '.'
  *                              to be a valid domain).  For example if you have a URL with a host of 'foo.bar.espn.com',
  *                              and you passed a value 3 as the subCount you'd get a string with a host of 'bar.espn.com'
  * @return {String}
  *
  */

function URLClass_toHostString(withProto, withPort, subCount)
{
	var ret = '',me = this,buffer = [],hst,val,
	hstSplit,hstSplitLen;

	if (me instanceof URLClass && isValid(me)) {
		hst = me[HOST] || '';

		if (hst) {
			hstSplit = hst.split('.');
			hstSplitLen = hstSplit.length;

			if (subCount < 0) {
				hstSplit.splice(0, subCount * -1);
				hst = hstSplit.join('.');

			} else if (subCount >= 2) {
				if (hstSplitLen > subCount) {
					hstSplit.splice(0, hstSplitLen - subCount);
					hst = hstSplit.join('.');
				}
			}

			buffer.push(hst);
		}

		if (withProto !== FALSE) {
			val = me[PRTCL] || '';
			if (val) {
				buffer.unshift(val, SCHEME_SEP);
			} else {
				buffer.unshift(DOUBLE_SLASH);
			}
		}

		if (withPort && hst) {
			val = me[PORT] || '';
			if (val) buffer.push(COLON, val);
		}

		ret = cstr(buffer);
	}
	return ret;
}

/**
   * Return whether or not the given URL has the same or similar origin to this URL.
   * For example (new fitt.URL('http://foo.espn.com')).isSub(new fitt.URL('http://espn.com')) == true.
   *
   * @name fitt.URL#isSub
   * @function
   * @public
   * @param {fitt.URL} other_url
   * @return {Boolean}
  */

function URLClass_isSub(other_url)
{
	var ret = FALSE,
	me = NULL,
	idx = -1;

	if (other_url && other_url instanceof URLClass) {
		me = other_url;
	} else {
		me = this;
		me = me && me instanceof URLClass ? me : NULL;
	}

	if (me) {
		if (me[PORT] === other_url[PORT] && me[PRTCL] === other_url[PRTCL]) {
			idx = me[HOST].lastIndexOf(other_url[HOST]);
			ret = !!(idx != -1 && idx + other_url[HOST][LEN] == me[HOST][LEN]);
		}
	}
	return ret;
}

/**
   * convert request from SEO to normal query string format
   *
   * SEO: http://www.espn.com/espn/story/_/id/23403800/mariano-rivera-misty-treanor-herschel-walker-designated-chair-president-council-sports-fitness-nutrition
   * query string: http://www.espn.com/espn/story?id=23403800&_slug_=mariano-rivera-misty-treanor-herschel-walker-designated-chair-president-council-sports-fitness-nutrition
   *
   * @name fitt.URL#undoSEO
   * @function
   * @public
   * @param  {String} Request url like above example
   * @return {String} query string format of url
   */

function URLClass_undoSEO(url) {
	var result = url,
	ampersand = '',
	questRegEx = /\?/,
	query,parts;

	if (typeof url === TYPE_STR && url.length) {
		parts = url.split('/_/');

		if (parts.length > 1) {
			result = [parts[0], QUEST]; //part before query string
			query = parts[1].split(FWD_SLASH);

			while (query.length > 1) {
				result.push(ampersand, query.shift(), EQ, fittStrReplace(query.shift(), questRegEx, AMP, FALSE, TRUE));
				ampersand = AMP;
			}

			if (query.length === 1) {
				result.push(ampersand, '_slug_=', fittStrReplace(query.shift(), questRegEx, AMP, FALSE, TRUE));
			}

			result = cstr(result);
		}
	}

	return result;
}

/**
   * The maximum number of characters a URL can be before it is considered invalid.
   *
   * @name fitt.URL.MAX_LENGTH
   * @type {Number}
   * @constant
   * @default 4096
   * @static
   *
  */

URLClass.MAX_LENGTH = URL_MAX_LENGTH;

URLClass.parse = parse;

URLClass.resolve = resolve;

URLClass.validate = validate;

URLClass.isSSL = isSSL;

URLClass.isAbsolute = isAbsolute;

URLClass.isSub = URLClass_isSub;

URLClass.loc = loc;

URLClass.ref = ref;

URLClass.undoSEO = URLClass_undoSEO;

URLClassProto.isValid = isValid;

URLClassProto.isSSL = isSSL;

URLClassProto.toStripString = URLClass_toStripString;
URLClassProto.toHostString = URLClass_toHostString;
URLClassProto.isSub = URLClass_isSub;

URLClassProto.toString =
URLClassProto.valueOf = URLClass_toString;
URLClass.prototype = URLClassProto;

/*
                                     * populate the prevLocStr, oBrowserLoc, prevRefStr, and oBrowserRef state objects
                                     * if possible
                                    */

if (!nodeURL) {
	loc();
	ref();
}

exp.URL = URLClass;

if (typeof module !== TYPE_UNDEF) {
	module.exports = URLClass;
}

if (!fitt.URL) {
	fitt.URL = URLClass;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-url/fittURL.js
// module id = 780
// module chunks = 0